import React from 'react';
import { motion } from 'framer-motion';
import './CreatorInfo.css';

const CreatorInfo = () => {
  return (
    <section className="creator-info">
      <motion.div 
        className="creator-card"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="creator-profile">
          <div className="creator-photo">
            <img 
              src="/images/foto-perfil.webp" 
              alt="Jesús Sagrario - Psicólogo Sanitario" 
              className="profile-image"
            />
          </div>
          <div className="creator-title">
            <h3>Creado por Jesús Sagrario</h3>
            <p className="creator-profession">Psicólogo Sanitario</p>
          </div>
        </div>
        
        <div className="creator-quote">
          <p>"He creado esta herramienta porque entender cómo nos sentimos es el primer paso para encontrar soluciones. Mi objetivo es ayudarte a determinar si podrías beneficiarte de apoyo profesional o recursos adicionales para tu bienestar emocional."</p>
        </div>
      </motion.div>
    </section>
  );
};

export default CreatorInfo;
